import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';

import { getCMSRequests } from 'network/cmsRequests';
import { APP_DOMAIN } from 'appenv';
import { fetchWebinars } from 'models/webinars';
import { eventsAdapter } from './selectors';
import { fetchCachedCMSData } from '../common/thunks';
import { CMSEvent, eventEntity } from './types';

export const fetchXtraEvent = createAsyncThunk(
  'events/fetchXtraEvent',
  async (_, { dispatch }) => {
    try {
      const response = await getCMSRequests().fetchXtraEvent({ domain: APP_DOMAIN });
      const { entities } = normalize<CMSEvent>([response.data], [eventEntity]);
      dispatch(fetchWebinars());
      return entities.events;
    } catch (error) {
      console.error(error);
    }
    return {};
  },
);

export const eventsSlice = createSlice({
  name: 'events',
  initialState: eventsAdapter.getInitialState({
    cachedCMSDataReady: false,
    cachedCMSDataError: false,
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCachedCMSData.rejected, (state) => {
      state.cachedCMSDataReady = false;
      state.cachedCMSDataError = true;
    });
    builder.addCase(fetchCachedCMSData.fulfilled, (state, action) => {
      eventsAdapter.upsertMany(state, action.payload.events);
      state.cachedCMSDataReady = true;
      state.cachedCMSDataError = false;
    });
    builder.addCase(fetchXtraEvent.fulfilled, (state, action) => {
      eventsAdapter.upsertMany(state, action.payload || {});
    });
  },
});

export default eventsSlice.reducer;
